<template>
  <svg
    class="type-svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- Association : deux personnes -->
    <template v-if="type === 'Association'">
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M16.5 14.3a5 5 0 0 1 4.5 5" />
    </template>

    <!-- Commerce : devanture -->
    <template v-else-if="type === 'Business'">
      <path d="M4 9 5.5 4h13L20 9" />
      <path d="M4 9a2.7 2.7 0 0 0 5.3 0 2.7 2.7 0 0 0 5.4 0A2.7 2.7 0 0 0 20 9" />
      <path d="M5.5 12v8h13v-8" />
      <path d="M10 20v-4h4v4" />
    </template>

    <!-- Autre : étincelles -->
    <template v-else-if="type === 'Other'">
      <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
      <path d="M19 16l.7 1.8 1.8.7-1.8.7L19 21l-.7-1.8-1.8-.7 1.8-.7z" />
    </template>

    <!-- Personnel : silhouette -->
    <template v-else>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </template>
  </svg>
</template>

<script setup>
import { defineProps } from "vue"

defineProps({
  type: { type: String, default: "Personal" }
})
</script>

<style scoped>
.type-svg {
  display: block;
  width: 1em;
  height: 1em;
  flex-shrink: 0;
}
</style>